import './app.css';

const LOCATION_QUERY_KEYS = ['lokalita', 'location', 'branch', 'pobocka'];
const PRICING_QUERY_KEY = 'balicek';
const PACKAGE_FIELD_SELECTORS = [
  'select[name="service-package"]',
  'select[name="your-package"]',
  'select[name="package"]',
  'select[name="balicek"]',
  'input[name="service-package"]',
  'input[name="your-package"]',
  'input[name="package"]',
  'input[name="balicek"]',
];
const SUBJECT_FIELD_SELECTORS = [
  'input[name="your-subject"]',
  'input[name="subject"]',
];
const CONTACT_SUCCESS_CLASSES = ['border-primary/30', 'bg-primary/10', 'text-primary'];
const CONTACT_ERROR_CLASSES = ['border-error/40', 'bg-error/10', 'text-error'];
const CONTACT_ERROR_MESSAGE = 'Formulář se nepodařilo odeslat. Zkuste to prosím později.';

function normalizeLocationValue(value) {
  return (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function getRequestedLocation() {
  const params = new URLSearchParams(window.location.search);

  for (const key of LOCATION_QUERY_KEYS) {
    const value = params.get(key);

    if (value) {
      return normalizeLocationValue(value);
    }
  }

  return '';
}

function syncLocationUrl(value) {
  const url = new URL(window.location.href);

  LOCATION_QUERY_KEYS.forEach((key) => url.searchParams.delete(key));

  if (value) {
    url.searchParams.set('pobocka', value);
  }

  window.history.replaceState({}, '', url);
}

function syncPricingUrl(plan) {
  const url = new URL(window.location.href);

  if (plan) {
    url.searchParams.set(PRICING_QUERY_KEY, plan);
  } else {
    url.searchParams.delete(PRICING_QUERY_KEY);
  }

  url.hash = 'contact';
  window.history.replaceState({}, '', url);
}

function dispatchFieldEvents(field) {
  field.dispatchEvent(new Event('input', { bubbles: true }));
  field.dispatchEvent(new Event('change', { bubbles: true }));
}

function setPackageFieldValue(field, plan) {
  if (!field || !plan) {
    return false;
  }

  if (field.tagName === 'SELECT') {
    const matchingOption = Array.from(field.options).find((option) => (
      normalizeLocationValue(option.value) === normalizeLocationValue(plan)
      || normalizeLocationValue(option.textContent) === normalizeLocationValue(plan)
    ));

    if (!matchingOption) {
      return false;
    }

    field.value = matchingOption.value;
    dispatchFieldEvents(field);
    return true;
  }

  field.value = plan;
  dispatchFieldEvents(field);
  return true;
}

function findFirstField(form, selectors) {
  for (const selector of selectors) {
    const field = form.querySelector(selector);

    if (field) {
      return field;
    }
  }

  return null;
}

function prefillContactForm(plan) {
  const contact = document.querySelector('#contact');
  const form = contact?.querySelector('form[data-contact-form]');

  if (!form || !plan) {
    return;
  }

  const packageField = findFirstField(form, PACKAGE_FIELD_SELECTORS);
  const subjectField = findFirstField(form, SUBJECT_FIELD_SELECTORS);
  const hasPackageField = setPackageFieldValue(packageField, plan);

  if (subjectField && (!subjectField.value || subjectField.dataset.pricingFilled === 'true')) {
    subjectField.value = hasPackageField ? `Poptavka: ${plan}` : `Poptavka na balicek: ${plan}`;
    subjectField.dataset.pricingFilled = 'true';
    dispatchFieldEvents(subjectField);
  }
}

function scrollToContact() {
  const contact = document.querySelector('#contact');

  if (!contact) {
    return;
  }

  contact.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function initPricingContactPrefill() {
  document.addEventListener('click', (event) => {
    const cta = event.target.closest('[data-pricing-cta]');

    if (!cta || cta.target === '_blank') {
      return;
    }

    const url = new URL(cta.href, window.location.href);

    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.hash !== '#contact') {
      return;
    }

    event.preventDefault();

    const plan = cta.dataset.pricingPlan || '';
    prefillContactForm(plan);
    syncPricingUrl(plan);
    scrollToContact();
  });

  const requestedPlan = new URLSearchParams(window.location.search).get(PRICING_QUERY_KEY);

  if (requestedPlan) {
    prefillContactForm(requestedPlan);
  }
}

function trackFormSend() {
  const branch = getRequestedLocation();
  const params = {};

  if (branch) {
    params.pobocka = branch;
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'form_send', params);
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'form_send', ...params });
  }
}

function getContactResponse(form) {
  return form.closest('[data-contact-form-card]')?.querySelector('[data-contact-form-response]');
}

function setContactResponse(form, status, message) {
  const response = getContactResponse(form);

  if (!response) {
    return;
  }

  const isSuccess = status === 'sent';
  const addClasses = isSuccess ? CONTACT_SUCCESS_CLASSES : CONTACT_ERROR_CLASSES;
  const removeClasses = isSuccess ? CONTACT_ERROR_CLASSES : CONTACT_SUCCESS_CLASSES;

  response.textContent = message || '';
  response.dataset.status = status || '';
  response.classList.toggle('hidden', !message);
  removeClasses.forEach((className) => response.classList.remove(className));
  addClasses.forEach((className) => response.classList.add(className));
}

async function refreshNonce(form) {
  const nonceUrl = form.dataset.nonceUrl;
  const field = form.querySelector('[name="cc_contact_nonce"]');

  if (!nonceUrl || !field) {
    return;
  }

  try {
    const response = await fetch(nonceUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    const data = await response.json();

    if (data && data.nonce) {
      field.value = data.nonce;
    }
  } catch (error) {
  }
}

function resetTurnstile(form) {
  const widget = form.querySelector('.cf-turnstile');

  if (!widget || !window.turnstile?.reset) {
    return;
  }

  window.turnstile.reset();
}

function initContactFormAjax() {
  document.querySelectorAll('[data-contact-form]').forEach((form) => {
    if (form.dataset.ajaxReady) {
      return;
    }

    form.dataset.ajaxReady = 'true';

    form.addEventListener('submit', async (event) => {
      const ajaxUrl = form.getAttribute('action');

      event.preventDefault();

      if (!ajaxUrl || !window.fetch || !window.FormData) {
        setContactResponse(form, 'error', CONTACT_ERROR_MESSAGE);
        return;
      }

      const submitButton = form.querySelector('[type="submit"]');

      setContactResponse(form, '', '');
      form.setAttribute('aria-busy', 'true');

      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        await refreshNonce(form);

        const formData = new FormData(form);

        const response = await fetch(ajaxUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        });
        const payload = await response.json();
        const data = payload.data || {};
        const status = data.status || (payload.success ? 'sent' : 'error');

        setContactResponse(form, status, data.message || CONTACT_ERROR_MESSAGE);

        if (payload.success) {
          trackFormSend();
          form.reset();
        }

        resetTurnstile(form);
      } catch (error) {
        setContactResponse(form, 'error', CONTACT_ERROR_MESSAGE);
        resetTurnstile(form);
      } finally {
        form.setAttribute('aria-busy', 'false');

        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    });
  });
}

function initMobileMenu() {
  const header = document.querySelector('[data-site-header]');
  const toggle = header?.querySelector('[data-mobile-menu-toggle]');
  const menu = header?.querySelector('[data-mobile-menu]');
  const openIcon = header?.querySelector('[data-mobile-menu-icon-open]');
  const closeIcon = header?.querySelector('[data-mobile-menu-icon-close]');

  if (!header || !toggle || !menu) {
    return;
  }

  const setOpen = (isOpen) => {
    menu.classList.toggle('hidden', !isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    openIcon?.classList.toggle('hidden', isOpen);
    closeIcon?.classList.toggle('hidden', !isOpen);
  };

  toggle.addEventListener('click', () => {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });

  menu.addEventListener('click', (event) => {
    if (event.target.closest('a')) {
      setOpen(false);
    }
  });

  document.addEventListener('click', (event) => {
    if (toggle.getAttribute('aria-expanded') === 'true' && !header.contains(event.target)) {
      setOpen(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setOpen(false);
    }
  });

  window.matchMedia('(min-width: 768px)').addEventListener('change', (event) => {
    if (event.matches) {
      setOpen(false);
    }
  });
}

function getLocations(section) {
  try {
    return JSON.parse(section.dataset.locations || '[]');
  } catch (error) {
    return [];
  }
}

function getLocationPosition(location) {
  const lat = Number(location.latitude);
  const lng = Number(location.longitude);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  return { lat, lng };
}

function getLocationQuery(location) {
  return [location.address, location.locality, location.name].filter(Boolean).join(', ');
}

function updateLocationEmbed(section, card) {
  const embed = section.querySelector('[data-location-map-embed]');
  const query = card?.dataset.locationMapQuery || '';

  if (!embed || !query) {
    return;
  }

  const nextSource = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;

  if (embed.getAttribute('src') !== nextSource) {
    embed.setAttribute('src', nextSource);
  }
}

function resolveLocationPosition(geocoder, location) {
  const position = getLocationPosition(location);

  if (position) {
    return Promise.resolve({ location, position });
  }

  const address = getLocationQuery(location);

  if (!address) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    if (!geocoder?.geocode) {
      resolve(null);
      return;
    }

    geocoder.geocode({ address }, (results, status) => {
      if (status !== 'OK' || !results?.[0]) {
        resolve(null);
        return;
      }

      const resultPosition = results[0].geometry.location;
      resolve({
        location,
        position: {
          lat: resultPosition.lat(),
          lng: resultPosition.lng(),
        },
      });
    });
  });
}

function setCardState(card, isActive) {
  card.classList.toggle('border-primary/20', isActive);
  card.classList.toggle('bg-surface-container-low', isActive);
  card.classList.toggle('border-outline-variant/10', !isActive);
  card.classList.toggle('ring-2', isActive);
  card.classList.toggle('ring-primary/30', isActive);
}

function initLocationSection(section) {
  const cards = Array.from(section.querySelectorAll('[data-location-card]'));
  const list = section.querySelector('[data-location-list]');
  const requestedLocation = getRequestedLocation() || normalizeLocationValue(section.dataset.activeLocation);
  let activeValue = requestedLocation;

  const applyFilter = (value, shouldSyncUrl = false) => {
    activeValue = value || '';
    let activeCard = null;

    cards.forEach((card) => {
      const locality = normalizeLocationValue(card.dataset.locationLocality);
      const slug = normalizeLocationValue(card.dataset.locationSlug);
      const isMatch = activeValue && (locality === activeValue || slug === activeValue);

      card.hidden = false;
      setCardState(card, false);

      if (!activeCard && isMatch) {
        activeCard = card;
      }
    });

    if (!activeCard) {
      activeValue = '';
      activeCard = cards[0] || null;
      if (shouldSyncUrl) {
        syncLocationUrl('');
      }
    }

    if (activeCard) {
      setCardState(activeCard, true);
      list?.prepend(activeCard);
      updateLocationEmbed(section, activeCard);
      if (shouldSyncUrl) {
        syncLocationUrl(activeCard.dataset.locationSlug);
      }
      section.dispatchEvent(new CustomEvent('cc:location-selected', {
        detail: {
          slug: activeCard.dataset.locationSlug,
          selectedOnly: Boolean(activeValue),
        },
      }));
    }
  };

  section.addEventListener('click', (event) => {
    const card = event.target.closest('[data-location-card]');

    if (card) {
      cards.forEach((item) => setCardState(item, item === card));
      updateLocationEmbed(section, card);
      syncLocationUrl(card.dataset.locationSlug);
      section.dispatchEvent(new CustomEvent('cc:location-selected', {
        detail: {
          slug: card.dataset.locationSlug,
          selectedOnly: true,
        },
      }));
    }
  });

  applyFilter(activeValue);
}

function initLocationMaps() {
  document.querySelectorAll('[data-locations-section]').forEach((section) => {
    const mapElement = section.querySelector('[data-location-map]');
    const embedElement = section.querySelector('[data-location-map-embed]');
    const fallback = section.querySelector('[data-location-map-fallback]');
    const fallbackImage = section.querySelector('[data-location-map-fallback-image]');
    const locations = getLocations(section).filter((location) => getLocationPosition(location) || getLocationQuery(location));

    if (!mapElement || mapElement.dataset.mapReady || !window.google?.maps || !locations.length) {
      return;
    }

    if (!window.google.maps.Map || !window.google.maps.Marker) {
      return;
    }

    const geocoder = window.google.maps.Geocoder ? new window.google.maps.Geocoder() : null;

    Promise.all(locations.map((location) => resolveLocationPosition(geocoder, location)))
      .then((resolvedLocations) => {
        const mapLocations = resolvedLocations.filter(Boolean);

        if (!mapLocations.length || mapElement.dataset.mapReady) {
          return;
        }

        mapElement.dataset.mapReady = 'true';
        mapElement.classList.remove('hidden');
        embedElement?.classList.add('hidden');
        fallback?.classList.add('hidden');
        fallbackImage?.classList.add('hidden');

        const activeCard = section.querySelector('[data-location-card]:not([hidden])');
        const firstLocation = mapLocations.find(({ location }) => location.slug === activeCard?.dataset.locationSlug) || mapLocations[0];
        const map = new window.google.maps.Map(mapElement, {
          center: firstLocation.position,
          zoom: 11,
          disableDefaultUI: true,
          zoomControl: true,
          styles: [
            { elementType: 'geometry', stylers: [{ color: '#151b2b' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: '#dde2f8' }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: '#0d1322' }] },
            { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#2f3445' }] },
            { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#080e1d' }] },
          ],
        });

        const bounds = new window.google.maps.LatLngBounds();
        const markers = mapLocations.map(({ location, position }) => {
          const marker = new window.google.maps.Marker({
            position,
            map,
            title: location.name,
          });

          bounds.extend(position);
          marker.addListener('click', () => {
            const card = Array.from(section.querySelectorAll('[data-location-card]'))
              .find((item) => item.dataset.locationSlug === location.slug);
            card?.click();
          });

          return { marker, location };
        });

        const focusMarker = (slug, selectedOnly = false) => {
          const selected = markers.find(({ location }) => location.slug === slug);

          if (!selected) {
            return false;
          }

          markers.forEach(({ marker }) => marker.setMap(selectedOnly ? null : map));
          selected.marker.setMap(map);
          map.panTo(selected.marker.getPosition());
          map.setZoom(selectedOnly ? 13 : 11);

          return true;
        };

        const requestedLocation = getRequestedLocation() || normalizeLocationValue(section.dataset.activeLocation);
        const activeLocationSelectedOnly = Boolean(requestedLocation && (
          normalizeLocationValue(firstLocation.location.slug) === requestedLocation
          || normalizeLocationValue(firstLocation.location.locality) === requestedLocation
        ));

        if (activeLocationSelectedOnly) {
          focusMarker(firstLocation.location.slug, true);
        } else if (markers.length > 1) {
          map.fitBounds(bounds, 80);
        } else {
          focusMarker(firstLocation.location.slug);
        }

        section.addEventListener('cc:location-selected', (event) => {
          focusMarker(event.detail.slug, Boolean(event.detail.selectedOnly));
        });
      });
  });
}

window.ccInitLocationMaps = initLocationMaps;

jQuery(function () {
  initMobileMenu();
  document.querySelectorAll('[data-locations-section]').forEach(initLocationSection);
  initPricingContactPrefill();
  initContactFormAjax();

  if (window.google?.maps) {
    initLocationMaps();
  }
});
